import axios from 'axios'

const state = {
  user: null,
  ability: localStorage.getItem('ability') || null,
  token: localStorage.getItem('token') || null,
  token_type: localStorage.getItem('token_type') || null,
}

const getters = {
  isAuthenticated: state => !!state.token,
  user : state => state.user
}

const actions = {
  async CheckUser({commit}, credentials) {
    return await axios.post("api/auth/user", credentials).then((res) => {
      commit("setToken", res.data.data);
    }).catch(function (error) {
      if (error.response) {
        console.log(error.response.data.message);
      }
      commit('LogOut')
    });
  },

  async LogIn({commit}, credentials) {
   await axios.get('/sanctum/csrf-cookie').then(async response => {
     return await axios.post("api/auth/login", credentials).then((res) => {
       commit("setToken", res.data.data);
     }).catch(function (error) {
       if (error.response) {
         console.log(error.response.data.message);
       }
       commit('LogOut')
     });
   });
  },

  async LogOut({ commit }) {
    return await axios.get("api/auth/logout").then(( res ) => {
      console.log(res.data.message);
      commit('LogOut')
    }).catch(function (error) {
      if (error.response) {
        console.log(error.response.data.message);
      }
      commit('LogOut')
    });
  },
}

const mutations = {
  setToken(state, data) {
    state.token = data.token.access_token;
    state.user = data.user;
    state.token_type = data.token.token_type;
    state.ability = data.ability;
    localStorage.setItem('ability', data.ability);
    localStorage.setItem('token', data.token.access_token);
    localStorage.setItem('token_type', data.token.token_type);
  },

  setUser(state, data) {
    state.user = data.user;
  },

  LogOut(state) {
    state.user = null
    state.token = null
    state.token_type = null
    state.ability = null
    localStorage.removeItem('ability');
    localStorage.removeItem('token');
    localStorage.removeItem('token_type');
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
